import axios from "axios";
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../auth/AuthProvider";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import LoadingSpinner from "../../../loadingSpinner/LoadingSpinner";

export default function AudioP1() {
  const { answerLabel, hashed, id, phaseTitle } = useParams();

  const {
    apiUrl,
    user,
    googleUser,
    payed,
    setUserProgress,
    userProgress,
    themePayed,
    setThemePayed,
  } = useContext(AuthContext);

  const [goToQuestion, setGoToQuestion] = useState(null);

  const [question, setQuestion] = useState([]);
  const [answer, setAnswer] = useState({});
  const [phase2, setPhase2] = useState([]);

  const [video, setVideo] = useState({});

  const [loading, setLoading] = useState(true);

  const [currentQuestion, setCurrentQuestion] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  const paidForTheme = useMemo(() => {
    return (themePayed?.[id]?.length ?? 0) > 0;
  }, [themePayed, id]);

  useEffect(() => {
    async function handleAxios() {
      const encodedLabel = encodeURIComponent(answerLabel);

      try {
        setLoading(true);

        const [question, phase, video] = await Promise.all([
          axios.get(`${apiUrl}/question/byPhaseAndTheme/${phaseTitle}/${id}`),
          axios.get(`${apiUrl}/question/byPhase/${2}`),
          axios.get(`${apiUrl}/answer/label/${encodedLabel}`),
        ]);

        setQuestion(question.data.sort((a, b) => a.id - b.id));
        setPhase2(phase.data.sort((a, b) => a.id - b.id));
        setVideo(video.data);

        // console.log(video.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    handleAxios();
  }, []);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        let endpoint = "";

        if (googleUser) {
          endpoint = `${apiUrl}/success/googleEmail/${googleUser.email}/${id}`;
        } else if (user) {
          endpoint = `${apiUrl}/success/username/${user.username}/${id}`;
        } else {
          return;
        }

        const response = await axios.get(endpoint);

        // Set correct theme payment state
        setThemePayed((prevState) => ({
          ...prevState,
          [id]: response.data,
        }));
      } catch (error) {
        console.error("Payment check failed:", error);
      }
    };

    fetchPaymentStatus();
  }, [user, googleUser, id, apiUrl]);

  useEffect(() => {
    if (question) {
      const index = question.findIndex((q) => q.hashed === hashed);
      const nextQuestion = index != -1 ? question[index + 1] : null;

      setCurrentQuestion(question[index]);

      if (nextQuestion !== null) setGoToQuestion(nextQuestion);
    }
  }, [question]);

  // useEffect(() => {
  //   if (!user && !googleUser) {
  //     localStorage.setItem("postLoginRedirect", location.pathname);
  //     navigate("/login", { replace: true });
  //   }
  // }, [user, googleUser, id, navigate]);

  useEffect(() => {
    if (!user && !googleUser) return;

    if (user) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        answerTitle: answerLabel,
        username: user.username,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }

    if (googleUser) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        answerTitle: answerLabel,
        googleEmail: googleUser.email,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }
  }, [user, googleUser]);

  function audioEnded() {
    if (goToQuestion) {
      if (user || googleUser || (!user && !googleUser)) {
        if (goToQuestion.text === "Question 1_3") {
          if (paidForTheme)
            navigate(`/session/${id}/${phaseTitle}/${goToQuestion.hashed}`);
          else navigate(`/pricing/${id}`);
        } else {
          navigate(`/session/${id}/${phaseTitle}/${goToQuestion.hashed}`);
        }
      }
      // console.log(goToQuestion);
    } else {
      if (user || googleUser) {
        navigate(`/session/${id}/${phase2[0].phaseTitle}/${phase2[0].hashed}`);
      } else {
        navigate("/login");
      }
    }
  }

  if (loading)
    return (
      <LoadingSpinner
        customBg={"rgba(20, 13, 8, 0.92)"}
        customColor={"white"}
      />
    );
  return (
    <>
      <AudioPlayer
        audioSrc={video?.reflectionVideoUrl}
        audioEnded={audioEnded}
        title={answerLabel}
        phase={phaseTitle}
        question={currentQuestion?.questionNumber}
        questionName={currentQuestion?.name}
        subtitle={video?.description}
      />
      {/* <section>
        <div>
          <audio
            src={`/${video?.reflectionVideoUrl}`}
            autoPlay
            controls
            onEnded={audioEnded}
          >
            Audio don't work
          </audio>
        </div>
      </section> */}
    </>
  );
}
